// PineconeDAO UI 設計規範 - SweetAlert2 配置
import Swal from "sweetalert2";
import { t } from "@/i18n";

// 注入自定義樣式
const injectCustomStyles = () => {
  if (document.getElementById('swal-custom-styles')) return;
  
  const style = document.createElement('style');
  style.id = 'swal-custom-styles';
  style.textContent = `
    /* SweetAlert2 自定義樣式 - 符合 PineconeDAO 設計規範 */
    
    /* 背景遮罩 */
    .swal2-backdrop {
      background: rgba(0, 0, 0, 0.85) !important;
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
    }
    
    /* 彈窗主體 */
    .swal-popup-black-gold {
      background: linear-gradient(135deg, #0d1a0d 0%, #0a1a0a 100%) !important;
      border: 1px solid rgba(16, 185, 129, 0.3) !important;
      border-radius: 20px !important;
      box-shadow: 
        0 24px 48px rgba(0, 0, 0, 0.8),
        0 0 60px rgba(16, 185, 129, 0.1),
        inset 0 1px 0 rgba(16, 185, 129, 0.2) !important;
      position: relative !important;
      overflow: hidden !important;
      padding: 32px !important;
    }
    
    /* 頂部光暈 */
    .swal-popup-black-gold::before {
      content: '';
      position: absolute;
      top: -100px;
      left: 50%;
      transform: translateX(-50%);
      width: 300px;
      height: 200px;
      background: radial-gradient(ellipse, rgba(16, 185, 129, 0.15) 0%, transparent 70%);
      filter: blur(40px);
      pointer-events: none;
    }
    
    /* 標題 */
    .swal2-title {
      color: #6ee7b7 !important;
      font-family: 'Lato Semibold', sans-serif !important;
      font-weight: 900 !important;
      font-size: 24px !important;
      margin-bottom: 16px !important;
      background: linear-gradient(90deg, #6ee7b7 0%, #10b981 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    /* 內容 */
    .swal2-html-container {
      color: #059669 !important;
      font-family: 'Source Han Sans', sans-serif !important;
      font-size: 16px !important;
      line-height: 1.5 !important;
      margin: 16px 0 24px !important;
    }
    
    /* 圖標容器 */
    .swal2-icon {
      border: none !important;
      margin: 0 auto 20px !important;
    }
    
    /* 成功圖標 */
    .swal2-success {
      border-color: rgba(78, 205, 196, 0.3) !important;
      color: #4ecdc4 !important;
    }
    
    .swal2-success-ring {
      border-color: rgba(78, 205, 196, 0.3) !important;
    }
    
    .swal2-success-line {
      background-color: #4ecdc4 !important;
    }
    
    /* 錯誤圖標 */
    .swal2-error {
      border-color: rgba(239, 68, 68, 0.3) !important;
      color: #ef4444 !important;
    }
    
    .swal2-x-mark-line {
      background-color: #ef4444 !important;
    }
    
    /* 信息圖標 */
    .swal2-info {
      border-color: rgba(16, 185, 129, 0.3) !important;
      color: #10b981 !important;
    }
    
    /* 警告圖標 */
    .swal2-warning {
      border-color: rgba(245, 158, 11, 0.3) !important;
      color: #f59e0b !important;
    }
    
    /* 按鈕容器 */
    .swal2-actions {
      gap: 12px !important;
      margin-top: 24px !important;
    }
    
    /* 確認按鈕 */
    .swal-button-gold {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
      color: #0a1a0a !important;
      border: none !important;
      border-radius: 12px !important;
      padding: 12px 32px !important;
      font-weight: 800 !important;
      font-size: 16px !important;
      text-transform: uppercase !important;
      letter-spacing: 1px !important;
      cursor: pointer !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      box-shadow: 
        0 4px 16px rgba(16, 185, 129, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    }
    
    .swal-button-gold:hover {
      transform: translateY(-2px) !important;
      background: linear-gradient(135deg, #6ee7b7 0%, #10b981 100%) !important;
      box-shadow: 
        0 8px 24px rgba(16, 185, 129, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.3) !important;
    }
    
    .swal-button-gold:active {
      transform: translateY(0) !important;
    }
    
    /* 取消按鈕 */
    .swal-button-gray {
      background: rgba(35, 35, 35, 0.8) !important;
      color: #059669 !important;
      border: 1px solid rgba(16, 185, 129, 0.3) !important;
      border-radius: 12px !important;
      padding: 12px 32px !important;
      font-weight: 700 !important;
      font-size: 16px !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
    }
    
    .swal-button-gray:hover {
      background: rgba(35, 35, 35, 0.95) !important;
      border-color: rgba(16, 185, 129, 0.5) !important;
      color: #6ee7b7 !important;
      transform: translateY(-1px) !important;
    }
    
    /* 加載動畫 */
    .swal2-loading {
      border-color: rgba(16, 185, 129, 0.2) !important;
      border-right-color: #10b981 !important;
    }
    
    /* 進度條 */
    .swal2-timer-progress-bar {
      background: linear-gradient(90deg, #10b981 0%, #6ee7b7 100%) !important;
      height: 3px !important;
    }
    
    /* 動畫 */
    .swal-show-animation {
      animation: swalSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    }
    
    .swal-hide-animation {
      animation: swalSlideOut 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;
    }
    
    @keyframes swalSlideIn {
      from {
        transform: scale(0.9) translateY(20px);
        opacity: 0;
      }
      to {
        transform: scale(1) translateY(0);
        opacity: 1;
      }
    }
    
    @keyframes swalSlideOut {
      from {
        transform: scale(1) translateY(0);
        opacity: 1;
      }
      to {
        transform: scale(0.95) translateY(10px);
        opacity: 0;
      }
    }
    
    /* 響應式 */
    @media (max-width: 768px) {
      .swal-popup-black-gold {
        width: 90% !important;
        margin: 0 5% !important;
        padding: 24px !important;
      }
      
      .swal2-title {
        font-size: 20px !important;
      }
      
      .swal2-html-container {
        font-size: 14px !important;
      }
      
      .swal-button-gold,
      .swal-button-gray {
        padding: 10px 24px !important;
        font-size: 14px !important;
      }
    }
  `;
  document.head.appendChild(style);
};

// 初始化樣式
injectCustomStyles();

// 預設配置
export const defaultSwal = Swal.mixin({
  timer: 1500,
  timerProgressBar: true,
  width: '420px',
  customClass: {
    popup: 'swal-popup-black-gold',
    confirmButton: 'swal-button-gold',
    cancelButton: 'swal-button-gray'
  },
  confirmButtonText: '確定',
  cancelButtonText: '取消',
  buttonsStyling: false,
  showClass: {
    popup: 'swal-show-animation'
  },
  hideClass: {
    popup: 'swal-hide-animation'
  }
});

// Translate at presentation time, preserving callbacks, amounts and transaction state.
const fire = defaultSwal.fire.bind(defaultSwal);
defaultSwal.fire = (options, ...rest) => {
  if (!options || typeof options !== 'object') return fire(t(options), ...rest.map(t));
  const localized = { ...options, confirmButtonText: t(options.confirmButtonText ?? '確定'), cancelButtonText: t(options.cancelButtonText ?? '取消') };
  for (const key of ['title', 'titleText', 'text', 'html', 'footer', 'inputLabel', 'inputPlaceholder'])
    if (key in localized) localized[key] = t(localized[key]);
  return fire(localized);
};

// 封裝常用通知方法，統一調用
export const notify = {
  info: (title = '提示', text = '', options = {}) =>
    defaultSwal.fire({ 
      icon: 'info', 
      title, 
      text,
      timer: 2000,
      ...options 
    }),
    
  success: (title = '操作成功', text = '', options = {}) =>
    defaultSwal.fire({ 
      icon: 'success', 
      title, 
      text,
      timer: 1500,
      ...options 
    }),
    
  error: (title = '操作失敗', text = '', options = {}) =>
    defaultSwal.fire({ 
      icon: 'error', 
      title, 
      text,
      timer: 3000,
      ...options 
    }),
    
  warning: (title = '警告', text = '', options = {}) =>
    defaultSwal.fire({ 
      icon: 'warning', 
      title, 
      text,
      timer: 2500,
      ...options 
    }),
    
  cancel: (title = '已取消', text = '用戶已取消操作', options = {}) =>
    defaultSwal.fire({ 
      icon: 'info', 
      title, 
      text,
      timer: 1500,
      ...options 
    }),
    
  loading: (title = '請稍候', text = '操作進行中...', options = {}) =>
    defaultSwal.fire({
      title,
      text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      timer: undefined,
      timerProgressBar: false,
      didOpen: () => {
        Swal.showLoading();
      },
      ...options
    }),
    
  confirm: (title = '確認操作', text = '', options = {}) =>
    defaultSwal.fire({
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      timer: undefined,
      timerProgressBar: false,
      ...options
    })
};